export default __webpack_public_path__ + "static/media/Dune-hd-7.cc3e4a27.jpg";